// extracted by mini-css-extract-plugin
export default {"sr-only":"Accessibility__sr-only--Jea6c","skip-to-content":"Accessibility__skip-to-content--rfCpC"};